import { CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import MahasiswaSidangService from "../../../../services/Integration/mahasiswa-sidang/MahasiswaSidangService";

import MKSpesialCard from "./MKSpesialCard";

export default function RiwayatMKSpesial() {
  const [isLoading, setIsLoading] = useState(false);
  const [sidangs, setSidangs] = useState([]);

  useEffect(() => getSidangs(), []);

  const getSidangs = async () => {
    setIsLoading(true);
    await MahasiswaSidangService.getMKSpesialMahasiswa().then((response) => {
      if (response.status === 200) {
        setSidangs(response.data.list_mk_spesial);
      }
    });
    setIsLoading(false);
  };

  return (
    <div className="mb-8">
      <h1>Riwayat MK Spesial</h1>
      <hr className="mb-4" />
      <div className="flex flex-wrap gap-4 items-center justify-center">
        {isLoading ? (
          <CircularProgress />
        ) : sidangs.length === 0 ? (
          <p className="font-bold">Anda belum memiliki riwayat sidang.</p>
        ) : (
          sidangs.map((mkspesial) => (
            <MKSpesialCard key={mkspesial.id} mKSpesial={mkspesial} />
          ))
        )}
      </div>
    </div>
  );
}
